













































































































import BasicTs from '@/components/mixins/basicts.vue';
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { Dictionary } from 'vue-router/types/router';

@Component({
mixins: [BasicTs]
})
export default class StartWithCode extends Mixins(BasicTs) {
  code: string = ''
  passwordRules: Array<(arg:string) => any> = [
    value => /[a-z]+/.test(value) || 'One lowercase letter required.',
    value => /[A-Z]+/.test(value) || 'One uppercase letter required.',
    value => /.{8,}/.test(value) || '8文字以上の文字が必要です',
    value => /[0-9]+/.test(value) || 'One number letter required.',
  ]
  emailRules: Array<(arg:string) => any> = [
    value => !!value || 'Required.',
    value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
  ]
  agreedTermsOfService = false
  tenantAddResult = false
  frmMail = false
  isSlackClicked = false
  get invitationCode () { return this.$store.direct.state.Tenant.invitationCode }
  get slackConnectURL () { return 'https://slack.com/oauth/v2/authorize?client_id=2494651943.1187490598167&scope=app_mentions:read,channels:history,reactions:read,channels:read,chat:write,emoji:read,groups:history,groups:write,groups:read,im:history,im:read,im:write,reactions:write,users.profile:read,users:read,users:read.email&user_scope=&state=' + (this.invitationCode?.tenantId ?? '') }
  get koosURL () { return 'https://' + (this.invitationCode?.tenantId ?? '')  + '.koosapp.com/'}
  async checkCode () {
    await this.$store.direct.dispatch.Tenant.getInvitationCode(this.code)
    if (this.invitationCode == null) {
      this.dispError('無効な招待コードです')
    } else {
      this.dispSuccess('招待コードの取得に成功しました。')
    }
  }
  async createSite () {
    this.tenantAddResult = await this.$store.direct.dispatch.Tenant.addTenant()
    if (this.tenantAddResult) {
      this.dispSuccess('招待コードの取得に成功しました。')
    } else {
      this.dispError('無効な招待コードです')
    }
  }
  async slackClicked () {
    this.isSlackClicked = true
    window.open(this.slackConnectURL)
  }
  async koosClicked () {
    this.$store.direct.commit.Tenant.SET_VALUE({name: 'invitationCode', value: null})
    this.isSlackClicked = false
    this.tenantAddResult = false
    this.$router.push('/')
  }
}
